import React from 'react'
import MapAndContact from './contact/MapAndContact'
import Event from './Event/Event'
import Galerie from './Galerie/Galerie'
import Home from './Home/Home'
import About from './Home/About'

export default function MainPart() {
    return (
        <div>
            <Home />
            <About />
            <Event />
            <Galerie />
            <MapAndContact />
        </div>
    )
}
